import React, { FC, SVGProps } from 'react';
import Box from '@mui/system/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { SvgIconComponent } from '@mui/icons-material';

interface SidebarInfoBlockProps {
  tooltip?: string;
  title?: string;
  value: string;
  icon: FC<SVGProps<SVGSVGElement>> | SvgIconComponent;
}

const SidebarInfoBlock: React.FC<SidebarInfoBlockProps> = ({ tooltip, title, value, icon }) => (
  <Tooltip title={tooltip} placement='right' arrow>
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minWidth: 0,
        alignItems: 'center',
        gap: '8px',
        cursor: 'help',
        overflow: 'hidden',
      }}
    >
      {icon && (
        <SvgIcon
          component={icon}
          inheritViewBox
          sx={{ color: 'typography.main', height: '15px', flexShrink: 0 }}
        />
      )}
      <Typography
        noWrap
        sx={{
          color: 'typography.main',
          fontSize: title === 'name' ? '12px' : '10px',
          fontWeight: title === 'name' ? '600' : '400',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}
      >
        {value}
      </Typography>
    </Box>
  </Tooltip>
);

export default SidebarInfoBlock;
